import { AppliedTimeOff } from '../shared/models/time-off.model';

/**
 * Parses TO_DATE string in DD/MM/YYYY format to a timestamp for comparison.
 * Invalid or missing dates return Number.MAX_SAFE_INTEGER so they sort to the end.
 */
function parseToDateTimestamp(toDate: string | null | undefined): number {
  if (!toDate || typeof toDate !== 'string') {
    return Number.MAX_SAFE_INTEGER;
  }
  const parts = toDate.trim().split('/');
  if (parts.length !== 3) {
    return Number.MAX_SAFE_INTEGER;
  }
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return Number.MAX_SAFE_INTEGER;
  }
  const date = new Date(year, month, day);
  if (isNaN(date.getTime())) {
    return Number.MAX_SAFE_INTEGER;
  }
  return date.getTime();
}

/**
 * Sorts pending approval records by TO_DATE (end date) ascending.
 * Oldest end date first, latest last. Date format is DD/MM/YYYY.
 * Returns a new array; does not mutate the input.
 */
export function sortPendingApprovalsByToDateAsc(list: AppliedTimeOff[]): AppliedTimeOff[] {
  if (!list || list.length === 0) {
    return [];
  }
  return [...list].sort((a, b) => {
    const tsA = parseToDateTimestamp(a.TO_DATE);
    const tsB = parseToDateTimestamp(b.TO_DATE);
    return tsA - tsB;
  });
}
